<template>
    
    <div>
        
    <v-card class="mb-8 elevation-10" :disabled="$store.getters.dialogLoaderMain || dialogLoader">

      <v-card-title v-if="!showAluno" class="body-2 grey darken-4">
        <span class="treino-title font-weight-black">{{item.dataTreinoFormattedBrasil}}</span>
        <v-spacer></v-spacer>
        <v-btn class="" outlined dark @click="updateFeedback()" v-if="$store.getters.userLogged.id == item.aluno.id">
          <v-icon left v-if="!item.feedback">mdi-plus</v-icon>
          <v-icon left v-if="item.feedback">mdi-pencil-outline</v-icon>
          feedback
        </v-btn>
      </v-card-title>
      <v-card-title v-if="showAluno" class="body-2 grey darken-4" style="font-size : 12px;">
        <v-row>
          <v-col cols="12" class="pb-0 text-left">
            <span class="treino-title font-weight-black">{{item.aluno.fullName}}</span>
          </v-col>
          <v-col cols="12" class="pt-0 text-left">
            <span class="treino-title">{{item.dataTreinoFormattedBrasil}}</span>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- <v-card-subtitle>{{item.esporte}}</v-card-subtitle> -->
      <v-card-text class="pt-0">
        <v-row dense v-for="(serieTreino, index) in item.seriesAsList" :key="serieTreino.id">
          
          <v-col cols="12" class="text-left">
            <treino-text-field :serieTreino="serieTreino" :esporte="item.esporte" class="pt-2"/>
          </v-col>

          <v-col cols="12" v-if="serieTreino.observacoes != null && serieTreino.observacoes != ''" class="text-left pt-3 pb-3 mt-n4">
            <div class="body-2 font-weight-black">Observações da série:</div>
            <div class="body-2">{{serieTreino.observacoes}}</div>
          </v-col>
          <v-col cols="12" class="pb-2 pt-0 mb-2" v-if="index < (item.seriesAsList.length-1)">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row v-if="item.feedback">
          <v-col cols="12">
            <v-divider></v-divider>
            <div class="font-weight-black mt-2">
              Feedback
            </div>
            <div class="text-justify">
              {{ item.feedback }}
            </div>
          </v-col>
        </v-row>
        
      </v-card-text>
      <v-card-actions class="pt-0 pb-2">
        <v-btn icon @click="clickShare(item)" v-if="$store.getters.userLogged.id == item.aluno.id" v-bind:color="item.shareThis ? 'primary' : 'grey'" v-bind:elevation="item.shareThis ? 5 : 0">
            <v-icon>mdi-share-variant</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div v-if="$store.getters.userLogged.id == item.aluno.id" class="">
            <v-btn icon @click="clickLike(item)" v-bind:color="item.loveThis ? 'red' : 'grey'" :disabled="$store.getters.dialogLoaderMain" v-bind:elevation="item.loveThis ? 5 : 0">
                <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon @click="clickHate(item)" v-bind:color="item.hateThis ? 'purple' : 'grey'" :disabled="$store.getters.dialogLoaderMain" v-bind:elevation="item.hateThis ? 5 : 0">
                <v-icon>mdi-heart-broken</v-icon>
            </v-btn>
            <!-- <v-btn icon>
                <v-icon>mdi-trash-can</v-icon>
            </v-btn> -->
        </div>
        <div v-else class="mt-n4">
            <v-btn icon v-if="item.loveThis" color="red">
                <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon v-if="item.hateThis" color="purple">
                <v-icon>mdi-heart-broken</v-icon>
            </v-btn>
            <!-- <v-btn icon>
                <v-icon>mdi-trash-can</v-icon>
            </v-btn> -->
        </div>
      </v-card-actions>
    </v-card>

    <!-- loader -->
    <div class="text-center">
        <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text class="pt-5">
            Espera só um pouquinho...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
        </v-dialog>
    </div>

    <!-- snackbar com os resultados -->
    <v-snackbar
      v-model="snackbarCardTreino"
      :timeout="snackDelay"
      :top="true"
      shaped
    >
      <v-row class="justify-center">
        {{ snackText }}
      </v-row>

    </v-snackbar> 

    <!-- dialog de feedback   -->
    <div class="text-center">
      <v-dialog
        v-model="dialogFeedback"
        width="500"
      >
        <v-card :disabled="$store.getters.dialogLoaderMain || dialogLoader">
          <v-card-title class="text-h5 primary">
            Feedback do treino
          </v-card-title>

          <v-card-text class="pa-5">
            
            <v-textarea outlined clearable counter maxlength="200" v-model="textFeedback">
            </v-textarea>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="textFeedback = null; dialogFeedback = false;"
            >
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!textFeedback || textFeedback.length < 3"
              color="primary"
              text
              @click="saveFeedback"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    </div>

  

</template>

<script>

import axios from "axios";
import HOST from "../ws/";
import {myMixin} from '../mixin';
import TreinoTextField from './TreinoTextField.vue';


// import axios from 'axios';
// import HOST from '../ws'
// import { required, minLength, email} from 'vuelidate/lib/validators'

export default {

  //axios,

  mixins : [
    myMixin
  ],

  components : {
    TreinoTextField
    
  },

  props: {
    item: Object,
    showAluno : Boolean,
  },

  data: () => ({
    
    myHost: HOST.HOST,

    dialogLoader : false,

    snackbarCardTreino : false,
    snackText : '',
    snackDelay : 4000,

    dialogFeedback : false,
    textFeedback : null,

  }),

  mounted(){
    //console.log(JSON.stringify(this.item));
    //console.log('\n-------\n\n');
  },

  methods : {

      updateFeedback(){
        this.textFeedback = this.item.feedback;
        this.dialogFeedback = true;
      },  

      clickLike(treino){
        
        //this.$store.getters.dialogLoaderMain = true;
        this.$store.commit("setLoader", true);
        const config = {
            headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };
        
        axios
            .post(this.myHost + "/treino/liketreino/" + treino.id, {}, config)
            .then(response => {
            treino.loveThis = !treino.loveThis;
            treino.hateThis = !treino.loveThis;
            console.log('click like : ' + response.status);  
            this.$store.commit("setLoader", false);
        })
        .catch(error => {
            console.log(error.message);
            this.$store.commit("setLoader", false);
            this.$store.commit("logout");
            this.$router.push("/");
       });
    },

    clickShare(treino){
        
        //this.$store.getters.dialogLoaderMain = true;
        this.dialogLoader = true;
        const config = {
            headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };
        
        axios
            .post(this.myHost + "/treino/sharetreino/" + treino.id, {}, config)
            .then(response => {
            console.log('click share : ' + response.data.shareThis);  
            treino.shareThis = response.data.shareThis;    
            if(response.data.shareThis){
                this.snackText = 'Treino compartilhado no feed';
            }else{
                this.snackText = 'Treino removido do feed';
            }
            this.snackbarCardTreino = true;
            this.dialogLoader = false;
        })
        .catch(error => {
            console.log(error.message);
            this.dialogLoader = false;
            this.$store.commit("logout");
            this.$router.push("/");
       });
    },

    clickHate(treino){

      this.$store.commit("setLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };

      axios
        .post(this.myHost + "/treino/hatetreino/" + treino.id, {}, config)
        .then(response => {
          treino.hateThis = !treino.hateThis;
          treino.loveThis = !treino.hateThis;
          console.log('click hate : ' + response.status);  
          this.$store.commit("setLoader", false);
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },

    saveFeedback(){

      this.$store.commit("setLoader", true);
      let requestData = {
        feedback : this.textFeedback,
        treinoId : this.item.id,
      }
      this.axios({
        method: 'post',
        url : HOST.HOST + '/treino/updatefeedback', 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : JSON.stringify(requestData)
      }).then((response) => {

        console.log('update do feedback: ' + response.status); 
        this.item = response.data;
        this.$store.commit("setLoader", false);
        this.dialogFeedback = false;

        this.snackText = "Feedback salvo";
        this.snackbarCardTreino = true;
        
        //console.log(JSON.stringify(this.items));
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
      });
      },
    }
};
</script>

<style>


</style>